import axios from 'axios';
import router from '@/router/index'
const API_URL = process.env.VUE_APP_API_HOST + '/api/studio';

const getAuthToken = () => localStorage.getItem('studio_jwt');

const authInterceptor = (config) => {
    const token = getAuthToken();
    if(token) {
        config.headers.Authorization = "Bearer" + token;
    }
    return config;
}


let config = {
    baseURL: API_URL,
    timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};

const Axios = axios.create(config);

Axios.interceptors.request.use(authInterceptor);
const UNAUTHORIZED = 401;

Axios.interceptors.response.use(
    response => response,
    error => {
    const {status} = error.response;
    if (status === UNAUTHORIZED) {
        router.push("/studios/sign-in/");
        localStorage.removeItem('studio_jwt')
        localStorage.removeItem('studio')
    }
    return Promise.reject(error);
}
);


function login(data) {
    let url = `${API_URL}/login`;
    return Axios.post(url, data)
}

function getClientsList(page) {
    const url = `${API_URL}/client?page=${page}`;
    return Axios.get(url);
}

function createClient(data) {
    const url = `${API_URL}/client`;
    return Axios.post(url, data);
}
function removeClient(client) {
    const url = `${API_URL}/client/${client}`;
    return Axios.delete(url);
}

function passCodeCheck(code) {
    let url = `${API_URL}/pass-code/check`;
    return Axios.post(url, code)
}
function passCodeCheckIn(code) {
    let url = `${API_URL}/pass-code/check-in`;
    return Axios.post(url, code)
}
function passCodeExtend(passCode) {
    let url = `${API_URL}/pass-code/${passCode}/extend`;
    return Axios.post(url)
}
function getMemberStatistics(page) {
    let url = `${API_URL}/visits-statistics/client?page=${page}`;
    return Axios.get(url);
}
function getGuestsStatistics(page) {
    let url = `${API_URL}/visits-statistics/guest?page=${page}`;
    return Axios.get(url);
}
function getPartnerStudios(options) {
    const { searchText, page } = options;
    let search = searchText ? searchText : '';
    let url = `${API_URL}/partner?page=${page}&search=${search}`;
    return Axios.get(url);
}
function getInactiveMembers(page) {
    let url = `${API_URL}/client/inactive?page=${page}`;
    return Axios.get(url);
}
function getUnapprovedMembers(page) {
    let url = `${API_URL}/client/unverified?page=${page}`;
    return Axios.get(url);
}
function approveUnverified(client) {
    let url = `${API_URL}/client/unverified/${client}/approve`;
    return Axios.post(url, {client: client});
}
function declineUnverified(client) {
    let url = `${API_URL}/client/unverified/${client}/decline`;
    return Axios.delete(url, {client: client});
}

function logout() {
    delete Axios.defaults.headers.Authorization;
    localStorage.removeItem("studio_jwt")
    return Promise.resolve('logout')
}




export {
    login,
    logout,
    passCodeCheck,
    passCodeCheckIn,
    passCodeExtend,
    getClientsList,
    createClient,
    removeClient,
    getMemberStatistics,
    getGuestsStatistics,
    getPartnerStudios,
    getInactiveMembers,
    getUnapprovedMembers,
    approveUnverified,
    declineUnverified
};